<template>
  <div class="select-product-input">
    <div v-if="envName === 'android'" class="select-product-input-mock">
      {{ fastSearchValue || $t("components_select_product_input_178") }}
    </div>
    <el-input
      v-else
      :value="fastSearchValue"
      :placeholder="$t('components_select_product_input_178')"
      suffix-icon="el-icon-search"
      @input="changeSearchValue"
      @change="prepareToSearch"
      name="select-product-input"
    ></el-input>
    <img
      class="page-header-container__center--keyboard"
      src="~@/assets/images/common/keyboard.png"
      alt=""
      @click="showSearchKeyboard"
    />
    <img
      class="page-header-container__center--keyboard"
      src="~@/assets/images/common/cearm.png"
      alt=""
      @click="showCreamFun"
      v-if="creamShow()"
    />
  </div>
</template>
<script>
import i18n from "../locales/index"
import { env } from "@/utils"

import { mapState, mapMutations } from "vuex"
import selectProductInput from "@/components/order-panel/selectProductInput.js"
const envName = env()

export default {
  name: "SelectProductInput",
  components: {},
  mixins: [selectProductInput],
  data() {
    return {
      keyfn: undefined,
      envName,
    }
  },
  mounted() {},
  beforeDestroy() {},
  computed: {
    ...mapState("shifangBridge", ["showCream","globalUseAi"]),
  },
  methods: {
    ...mapMutations("shifangBridge", ["SET_IS_AIMODE", "SET_CREAM"]),
    // 切换快速搜索
    showSearchKeyboard() {
      this.SET_SHOW_FAST_SEARCH(!this.showFastSearch)
      console.log(this.showFastSearch)

      if (!this.showFastSearch) {
        this.SET_IS_AIMODE(false)
      }
    },
    creamShow() {
      if (envName === "android") {
        if (this.globalUseAi) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    showCreamFun() {
      if (envName === "android") {
        this.SET_CREAM()

        if (this.showCream) {
          this.$message.success({
            message: "已开启AI学习模式，此模式下点击任何商品即可进行学习",
            duration: 1000,
          })
        } else {
          this.$message.warning({
            message: "已关闭AI学习模式，此模式主动搜索商品点击才可进行学习",
            duration: 1000,
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.select-product-input {
  display: flex;
  align-items: center;
  width: 560px;
  height: 44px;
  > div {
    width: 100% !important;
    border: 1px solid rgba(143, 143, 143, 0.6);
    border-radius: 200px;
    overflow: hidden;

    ::v-deep .el-input__inner {
      background: rgba(253, 220, 220, 0.2);
      border: none;
    }

    .el-input__suffix {
      right: 15px;
      font-weight: 500;
      font-size: 15px;
    }
  }
  &-mock {
    font-size: 20px;
    color: #8f8f8f;
    padding: 16px 16px;
  }

  &--keyboard {
    width: 74px;
    height: 74px;
    margin-left: 20px;
  }
}

.pickSeting {
  width: 45px;
  height: 45px;
  margin-left: 20px;
}
</style>
